import { render, staticRenderFns } from "./shopnoticetempl.vue?vue&type=template&id=3eb5d432&scoped=true"
import script from "./shopnoticetempl.vue?vue&type=script&lang=js"
export * from "./shopnoticetempl.vue?vue&type=script&lang=js"
import style0 from "./shopnoticetempl.vue?vue&type=style&index=0&id=3eb5d432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb5d432",
  null
  
)

export default component.exports